module.exports = __webpack_public_path__ + "static/media/Active.91f6a83b.png";